import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HelpCircleIcon, ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Ya tengo mi barbero, por qué cambiar?',
    a: 'Todos nuestros clientes frecuentes también tenían uno. Luego probaron El Ritual Delux una vez — y ya no volvieron a ningún otro lado. Una visita. Eso es todo lo que pedimos.'
  }, {
    q: '¿Vale la pena ir hasta Sunshine Plaza?',
    a: 'El mejor corte de tu vida siempre vale el viaje. Y una vez que seas cliente regular, te preguntarás por qué esperaste tanto.'
  }, {
    q: '¿Tendré que esperar mucho tiempo?',
    a: 'Recomendamos reservar con anticipación — nuestros clientes vuelven de forma consistente. Llama al (786) 651-6944 para asegurar tu horario.'
  }, {
    q: '¿Y si no me gusta el corte?',
    a: 'Dínoslo. Lo corregimos. Siempre. No es una política — es una promesa.'
  }, {
    q: '¿Aceptan sin cita previa?',
    a: 'Sí — siempre se aceptan sin cita. Se recomienda reservar para garantizar tu horario preferido.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="contacto" className="bg-delux-alt py-20 px-4 sm:px-6 lg:px-8 border-t border-delux-gold/10" data-id="element-50">
      <div className="max-w-3xl mx-auto" data-id="element-51">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-52">
          <HelpCircleIcon className="w-10 h-10 text-delux-gold mx-auto mb-6" data-id="element-53" />
          <h2 className="font-heading text-3xl md:text-4xl text-delux-gold mb-4" data-id="element-54">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-55">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-delux-card border border-delux-gold/20 rounded-lg overflow-hidden" data-id="element-56">
              <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-delux-gold/5 transition-colors" aria-expanded={openIndex === index} data-id="element-57">
                <span className="font-heading text-xl text-delux-white" data-id="element-58">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-delux-gold transition-transform duration-300 ${openIndex === index ? 'transform rotate-180' : ''}`} data-id="element-59" />
              </button>

              <AnimatePresence data-id="element-60">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-61">
                    <div className="px-6 pb-5 pt-2 text-delux-body font-body text-lg border-t border-delux-gold/10" data-id="element-62">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}